module.exports = __webpack_public_path__ + "static/media/zip-simple-icon.8ee6fba5.svg";